import { URLS } from 'services/urls';
import { FEATURE } from 'services/constants';
import { SectionConfig, SubsectionConfig } from './types';

export const DEBOUNCE_DELAY_MS = 400;

export const PORTFOLIO_ANALYTICS_PRO_ADDON_ID = 1;

export const DEVELOPMENT_PROJECTS_SUBSECTION: SubsectionConfig = {
    title: 'Development Projects',
    items: [
        {
            label: 'Portfolio dashboard',
            url: URLS.PROJECTS_APP.PROJECTS,
        },
    ],
};

export const INVOICES_SUBSECTION: SubsectionConfig = {
    title: 'Other tools',
    items: [
        {
            label: 'Portfolio invoices',
            url: URLS.PROJECTS_APP.PORTFOLIO_INVOICES,
            feature: FEATURE.PORTFOLIO_INVOICE_DATA_INDEX,
            enterpriseRequired: true,
        },
        {
            label: 'Vendor Directory',
            url: URLS.PROJECTS_APP.VENDOR_DIRECTORY,
            feature: FEATURE.VENDOR_DIRECTORY,
        },
        {
            label: 'Budget Categorizations',
            url: URLS.PROJECTS_APP.PORTFOLIO_BUDGET_CATEGORIZATIONS,
            feature: FEATURE.PORTFOLIO_BUDGET_CATEGORIZATIONS,
        },
    ],
};

export const ANALYTICS_BENCHMARK_SUBSECTION: SubsectionConfig = {
    title: 'Benchmark',
    items: [
        {
            label: 'Cost Analytics',
            url: URLS.PROJECTS_APP.COST_ANALYTICS,
            feature: FEATURE.PORTFOLIO_COST_ANALYTICS,
        },
        {
            label: 'Quick Analytics',
            url: URLS.PROJECTS_APP.QUICK_ANALYTICS,
            feature: FEATURE.QUICK_ANALYTICS,
        },
        {
            label: 'Vendor Analytics',
            url: URLS.PROJECTS_APP.VENDOR_ANALYTICS,
            feature: FEATURE.PORTFOLIO_VENDOR_ANALYTICS,
        },
    ],
};

export const ANALYTICS_FORECAST_SUBSECTION: SubsectionConfig = {
    title: 'Forecast',
    items: [
        {
            label: 'Developer Fee',
            url: URLS.PROJECTS_APP.DEVELOPER_FEE,
            feature: FEATURE.PORTFOLIO_DEVELOPER_FEE,
        },
        {
            label: 'Global Cost Forecast',
            url: URLS.PROJECTS_APP.GLOBAL_COST_FORECAST_V2,
            feature: FEATURE.GLOBAL_COST_FORECAST_V2,
        },
        {
            label: 'Portfolio Capital Planning',
            url: URLS.PROJECTS_APP.PORTFOLIO_CAPITAL_PLANNING,
            feature: FEATURE.PORTFOLIO_CAPITAL_PLANNING,
        },
    ],
};

export const MENU_SECTIONS: SectionConfig[] = [
    {
        title: 'Northspyre Development',
        subsections: [DEVELOPMENT_PROJECTS_SUBSECTION, INVOICES_SUBSECTION],
        hasBorder: true,
    },
    {
        title: 'Approvals',
        items: [
            {
                label: 'AI-Extracted Deal Documents',
                url: URLS.PROJECTS_APP.APPROVALS,
            },
        ],
        hasBorder: true,
    },
    {
        title: 'Analytics',
        subsections: [],
        hasBorder: true,
        requiresCoreAccess: true,
    },
];
